import React from 'react';
import _ from 'lodash';

import { USER_ROLES } from '../utilities/constants';
import { FormItem } from './FormBase';
import { FormListItem, FormElement } from '../components/CommonFormComponents';
import {
  InputForm,
  FileInputForm,
  FormDropDownSingleSelect,
} from './CommonFormComponents';
import {
  PartnerCompanyBranchDropdown,
  HEAD_OFFICE_OPTION,
} from '../components/PartnerCompanyBranchDropdown';
import { createLocalEventManager } from '../utilities/EventManager';
import RequireIcon from '../components/RequireIcon';
import { messageUtility } from '../utilities/messageUtility';

// パスワードの表示・非表示
const eventMg = createLocalEventManager({
  VISIBLE_PASSWORD: 'visible_password',
  VISIBLE_CURRENT_PASSWORD: 'visible_current_password',
});

/**
 * @description 画像ファイルアイコン & アップロード
 */
export const IconForm = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='アイコン画像'>
        <FileInputForm
          {...newProps}
          validate={props.validate}
          info={props.info}
        />
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description ユーザー種別 (表示だけ))
 */
export const UserType = props => (
  <FormListItem label='ユーザー種別'>
    <FormElement>
      {(() => {
        for (let key in USER_ROLES) {
          if (USER_ROLES[key].id === props.value) {
            return USER_ROLES[key].name;
          }
        }
      })()}
    </FormElement>
  </FormListItem>
);

/**
 * @description 所属会社 (表示だけ)
 * ログインユーザーが職長の場合のみ表示される項目。
 * 非活性項目。自身の所属会社名を表示する。
 */
export const AffCompany = props => (
  <FormListItem label='所属会社'>
    <FormElement>{props.defaultValue}</FormElement>
  </FormListItem>
);

/**
 * @description 所属支店 (表示だけ)
 * 本社管理者は表示されない
 * 非活性項目。自身の所属会社名を表示する。
 */
export const BranchCompany = props => (
  <FormListItem label='支店'>
    <FormElement>{props.defaultValue}</FormElement>
  </FormListItem>
);

export const PartnerCompanyBranch = ({
  selectedCompanyId,
  defaultValue,
  onSelect,
  isManagerPermission,
  ...restProps
}) => {
  return (
    <FormListItem label='支店' required={isManagerPermission}>
      <FormElement info='支店のデフォルトは本社となります。支店の登録、支店への配属は企業管理者のみが実行できます。'>
        <PartnerCompanyBranchDropdown
          selectedCompanyId={selectedCompanyId}
          selectedPartnerCompanyBranchId={_.get(
            defaultValue,
            'id',
            HEAD_OFFICE_OPTION.id
          )}
          previewValue={_.get(defaultValue, 'name', HEAD_OFFICE_OPTION.name)}
          onSelect={onSelect}
          fixedOptions={[HEAD_OFFICE_OPTION]}
          disabled={!isManagerPermission}
          {...restProps}
        />
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description 部署 (表示だけ)
 * 元請けのみ
 * 非活性項目。自身の所属会社名を表示する。
 */
export const Department = props => (
  <FormListItem label='所属部署'>
    <FormElement>{props.defaultValue}</FormElement>
  </FormListItem>
);

/**
 *
 *@description ユーザー種別
 */
export const UserTypeDisabled = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='ユーザー種別'>
        <FormElement validate={props.validate}>
          <InputForm {...newProps} placeholder='（例）山田' />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 姓
 */
export const LastName = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='姓' required={!props.disabled}>
        <FormElement validate={props.validate}>
          <InputForm {...newProps} placeholder='（例）山田' maxLength={64} />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 名
 */
export const FirstName = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='名' required={!props.disabled}>
        <FormElement validate={props.validate}>
          <InputForm {...newProps} placeholder='（例）太郎' maxLength={64} />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description せい
 */
export const LastNameKana = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='せい' required={!props.disabled}>
        <FormElement validate={props.validate}>
          <InputForm {...newProps} placeholder='（例）やまだ' maxLength={128} />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description めい
 */
export const FirstNameKana = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='めい' required={!props.disabled}>
        <FormElement validate={props.validate}>
          <InputForm {...newProps} placeholder='（例）たろう' maxLength={128} />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 電話番号
 */
export const Tel = props => (
  <FormItem {...props}>
    {newProps => {
      const value =
        !_.isEmpty(newProps.value) && _.isString(newProps.value)
          ? newProps.value
          : '--';
      const [num1, num2, num3] = value.split('-');

      return (
        <FormListItem label='電話番号'>
          <FormElement validate={props.validate}>
            <label htmlFor='tel' className='input-tel'>
              <InputForm
                {...newProps}
                value={num1}
                placeholder={props.disabled === true ? '' : '03'}
                maxLength={5}
                params={val => value.replace(/^[^-]*-/, `${val}-`)}
              />
              -
              <InputForm
                {...newProps}
                value={num2}
                placeholder={props.disabled === true ? '' : '1234'}
                maxLength={4}
                params={val => value.replace(/-[^-]*-/, `-${val}-`)}
              />
              -
              <InputForm
                {...newProps}
                value={num3}
                placeholder={props.disabled === true ? '' : '5678'}
                maxLength={4}
                params={val => value.replace(/-[^-]*$/, `-${val}`)}
              />
            </label>
          </FormElement>
        </FormListItem>
      );
    }}
  </FormItem>
);

/**
 * @description FAX
 * ログインユーザーが協力会社管理者の場合のみ表示される項目。
 */
export const Fax = props => (
  <FormItem {...props}>
    {newProps => {
      const value =
        !_.isEmpty(newProps.value) && _.isString(newProps.value)
          ? newProps.value
          : '--';
      const [num1, num2, num3] = value.split('-');

      return (
        <FormListItem label='FAX番号'>
          <FormElement validate={props.validate}>
            <label htmlFor='Fax' className='input-tel'>
              <InputForm
                {...newProps}
                value={num1}
                placeholder={props.disabled === true ? '' : '03'}
                maxLength={5}
                params={val => value.replace(/^[^-]*-/, `${val}-`)}
              />
              -
              <InputForm
                {...newProps}
                value={num2}
                placeholder={props.disabled === true ? '' : '1234'}
                maxLength={4}
                params={val => value.replace(/-[^-]*-/, `-${val}-`)}
              />
              -
              <InputForm
                {...newProps}
                value={num3}
                placeholder={props.disabled === true ? '' : '5678'}
                maxLength={4}
                params={val => value.replace(/-[^-]*$/, `-${val}`)}
              />
            </label>
          </FormElement>
        </FormListItem>
      );
    }}
  </FormItem>
);

/**
 * @description ユーザーID(メールアドレス)
 * ログインユーザーが元請ユーザー、または協力会社管理者の場合のみ表示される項目
 */
export const Email = props => {
  return (
    <FormItem {...props}>
      {newProps => (
        <FormListItem
          label='ユーザーID（メールアドレス）'
          required={!props.disabled}
        >
          <FormElement validate={props.validate}>
            <InputForm
              {...newProps}
              placeholder='メールアドレスを入力'
              maxLength={256}
              className='form-list__input-large'
            />
          </FormElement>
        </FormListItem>
      )}
    </FormItem>
  );
};

/**
 * @description ユーザーID
 * ログインユーザーが職長の場合のみ表示される項目。
 */
export const UserId = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='ユーザーID' required={!props.disabled}>
        <FormElement
          validate={props.validate}
          info={messageUtility.getMessage('I-001-252')}
        >
          <InputForm {...newProps} placeholder='ユーザーIDを入力' />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description パスワードフォームの共通パーツ
 */
const PasswordForm = ({ passwordVisible, props, newProps }) => {
  return (
    <FormElement validate={props.validate}>
      <InputForm
        {...newProps}
        type={passwordVisible ? 'text' : 'password'}
        maxLength={32}
      />
    </FormElement>
  );
};

/**
 * @description パスワード（変更後）
 */
export class Password extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 必須の表示非表示（デフォルトはtrue）
      isRequired: this.propsv0sRequired || true,
      passwordVisible: false,
    };
  }

  render() {
    return (
      <FormItem {...this.props}>
        {newProps => (
          <li className='form-list__item form-list__item--child'>
            <div className='form-list__label'>
              <span className='label'>
                新しいパスワード
                <RequireIcon isShow={this.state.isRequired} />
                <span className='login-label__sub'>
                  <div
                    className={`btn-password-visible${
                      this.state.passwordVisible ? '' : ' invisible'
                    }`}
                    onClick={() => {
                      eventMg.trigger(
                        'visible_password',
                        !this.state.passwordVisible
                      );
                      this.setState({
                        passwordVisible: !this.state.passwordVisible,
                      });
                    }}
                  />
                </span>
              </span>
            </div>
            <PasswordForm
              passwordVisible={this.state.passwordVisible}
              props={this.props}
              newProps={newProps}
            />
          </li>
        )}
      </FormItem>
    );
  }
}

/**
 * @description パスワード確認（変更後）
 */
export class PasswordConf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 必須の表示非表示（デフォルトはtrue）
      isRequired: this.propsv0sRequired || true,
      passwordVisible: false,
    };
    eventMg.addEventListener('visible_password', this.visible);
  }

  visible = visible => {
    this.setState({ passwordVisible: visible });
  };

  componentWillUnmount() {
    eventMg.removeEventListener('visible_password', this.visible);
  }

  render() {
    return (
      <FormItem {...this.props}>
        {newProps => (
          <FormListItem
            label='新しいパスワード（再入力）'
            required={true}
            className='form-list__item form-list__item--child'
          >
            <PasswordForm
              passwordVisible={this.state.passwordVisible}
              props={this.props}
              newProps={newProps}
            />
          </FormListItem>
        )}
      </FormItem>
    );
  }
}

/**
 * パスワードOn/Offチェックボックス
 *
 * @export
 * @class PasswordCheckbox
 * @extends {React.Component}
 */
export class PasswordCheckbox extends React.Component {
  // styleの調整目的でのみ使用している
  state = {
    isChecked: false,
  };
  handleChange = event => {
    this.setState({
      isChecked: event.target.checked,
    });
  };
  render() {
    const { disableByIntegrated, ...restProps } = this.props;
    const listStyle = this.state.isChecked
      ? 'form-list__item form-list__item--open'
      : 'form-list__item';
    return (
      <FormItem {...restProps}>
        {newProps => (
          <FormListItem label='パスワード' className={listStyle}>
            <FormElement>
              {!disableByIntegrated ? (
                <label className='checkbox'>
                  <input
                    type={'checkbox'}
                    onChange={event => {
                      this.handleChange(event);
                      this.props.callback({
                        [newProps.id]: event.target.checked,
                      });
                    }}
                  />
                  <i className='i-square i-3x' />
                  パスワードを変更する
                </label>
              ) : (
                'このユーザーは統合されているため、パスワードの変更は行えません。パスワードを変更したい場合は他のユーザーに操作を切り替えてください。'
              )}
            </FormElement>
          </FormListItem>
        )}
      </FormItem>
    );
  }
}

/**
 * @description 現在のパスワード
 */
export class CurrentPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 必須の表示非表示（デフォルトはtrue）
      isRequired: this.propsv0sRequired || true,
      currentPasswordVisible: false,
    };
  }

  render() {
    return (
      <FormItem {...this.props}>
        {newProps => (
          <li className='form-list__item form-list__item--child'>
            <div className='form-list__label'>
              <span className='label'>
                現在のパスワード
                <RequireIcon isShow={this.state.isRequired} />
                <span className='login-label__sub'>
                  <div
                    className={`btn-password-visible${
                      this.state.currentPasswordVisible ? '' : ' invisible'
                    }`}
                    onClick={() => {
                      eventMg.trigger(
                        'visible_current_password',
                        !this.state.currentPasswordVisible
                      );
                      this.setState({
                        currentPasswordVisible: !this.state
                          .currentPasswordVisible,
                      });
                    }}
                  />
                </span>
              </span>
            </div>
            <PasswordForm
              passwordVisible={this.state.currentPasswordVisible}
              props={this.props}
              newProps={newProps}
            />
          </li>
        )}
      </FormItem>
    );
  }
}

/**
 * @description 必須ではない Email
 * ログインユーザーが職長の場合のみ表示される項目。
 */
export const SubEmail = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='メールアドレス' isRecommended={true}>
        <FormElement
          validate={props.validate}
          info={messageUtility.getMessage('I-001-418')}
        >
          <InputForm
            {...newProps}
            placeholder={props.disabled === true ? '' : 'メールアドレスを入力'}
            className='form-list__input-large'
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 支店
 * 自身が所属する支店を表示する。本社管理者の場合は、空欄。
 */
export const Shiten = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='支店'>
        <FormElement>
          <FormDropDownSingleSelect
            label='支店を指定'
            placeholder='支店名を選択'
            apiPath='/api/private/company_branches/list'
            entitiesKey='company_branches'
            disabled={props.disabled}
            setDefaultValue={list => {
              for (let i in list) {
                if (newProps.value === list[i].id) {
                  return list;
                }
              }
            }}
            callback={value => newProps.onUpdate(value, value.id)}
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);



// WEBPACK FOOTER //
// ./src/components/UserProfileFormElements.jsx